import { Component, ViewChild } from "@angular/core"
import { App, Slides } from "ionic-angular"

import { AppLocalStorage } from "../../services/app-local-storage"
import { AppTabPages } from "../tabs"

@Component({
  selector: "welcome-page",
  templateUrl: "index.html",
})
export class WelcomePage {

  @ViewChild(Slides) slides: Slides

  constructor(
    private appCtrl: App
  ) {}

  onSlideTap() {

    this.slides.slideNext()
  }

  onStartUsing() {

    AppLocalStorage.set("viewedSlides", true)

    this.appCtrl.getRootNavs()[0].setRoot(AppTabPages, {}, { animate: true, direction: "forward" })
  }
}



// WEBPACK FOOTER //
// ./src/pages/welcome/index.ts